<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './css/common.css'
import './css/font.css'
import './css/footer.css'
import './css/header.css'
import './css/input.css'
import './css/mobile.css'
import './css/paginate.css'

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Noto Sans KR', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue